module.exports = __webpack_public_path__ + "media/images/Truck 1300 900-a9c7c5f1.jpg";